module.exports = __webpack_public_path__ + "static/media/st-xenia-volunteers.50314d56.jpg";